import React, { useState } from "react";
import { InlineTooltipContent ,Button, Href} from "../../../../../Constant";
import { Btn, H5, P, ToolTip } from "../../../../../AbstractElements";

export const InlineTooltip = () => {
  const [basictooltip, setbasictooltip] = useState(false);
  const toggle = () => setbasictooltip(!basictooltip);
  return (
    <div>
      <H5 className="mb-1 py-4 pb-0">{InlineTooltipContent}</H5>
      <P>
        Here, is some content about tooltips that you can set the
        <a id="Tooltip-2" className="txt-primary fw-bold ms-1 me-1" href={Href}>tooltip</a>
        inside the content with help of tooltip and also you can add
        <Btn id="Tooltip-2" color="success" className="text-white border-0 px-3 py-1 me-1 ms-1 mb-0 " data-bs-title="button">{Button}</Btn>
        Tooltips helps you to add more and more content. A tooltip is often used to specify extra information about something when the user moves the mouse pointer over an element
      </P>
      <ToolTip target="Tooltip-2" placement="top" isOpen={basictooltip} toggle={toggle}>tooltip</ToolTip>
      <ToolTip target="Tooltip-2" placement="top" isOpen={basictooltip} toggle={toggle}>button</ToolTip>
    </div>
  );
};
